import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Loading from 'components/Selfcare/Common/Loading';
import Button from "components/CustomButtons/Button";

class Prepaid extends React.Component {

    render() {
        const { subscription, classes, navigateTo } = this.props;
        return (
            <GridContainer direction="row" justify="center" alignItems="center" name="prepaidroot">
                <Hidden smDown><GridItem md={3}>
                    <div style={{ width: '100%', textAlign: 'right' }}>
                        <span style={{ color: '#e91e63', fontSize: '20px', paddingRight: '20px' }}>{subscription.FormattedMsisdn} - {subscription.Priceplan.Name}</span>
                    </div>
                </GridItem></Hidden>
                <GridItem>
                    <div className={classes.content}>
                        <Hidden mdUp>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <span style={{ color: '#e91e63', fontSize: '20px' }}>{subscription.FormattedMsisdn} - {subscription.Priceplan.Name}</span>
                            </div>
                        </Hidden>
                        {subscription && !subscription.SaldoLoading ?
                            (
                                <GridContainer justify="center">
                                    <GridItem>
                                        <div style={{ paddingTop: '10px', paddingBottom: '20px', paddingRight: '5px' }}>
                                            <GridContainer justify="center" alignItems="center" spacing={0} style={{ width: '280px', height: '280px' }}>
                                                <GridItem>
                                                    <div style={{ fontSize: '14px', color: '#c0c0c0', textAlign: 'center' }}>Saldo</div>
                                                    {subscription && subscription.Saldo && <div style={{ lineHeight: '1', textAlign: 'center', color: '#e91e63', width: '280px' }} dangerouslySetInnerHTML={{ __html: subscription.Saldo }} />}
                                                    {subscription && subscription.SaldoError && <div style={{ fontSize: '14px', textAlign: 'center' }}>{subscription.SaldoError}</div>}
                                                </GridItem>
                                                {subscription && subscription.HasDataPot && <GridItem>
                                                    <div style={{ fontSize: '14px', color: '#c0c0c0', textAlign: 'center' }}>Gjenstående data</div>
                                                    {subscription && subscription.DataPot && <div style={{ lineHeight: '1', textAlign: 'center', color: '#e91e63', width: '280px', fontSize: '50px' }} dangerouslySetInnerHTML={{ __html: subscription.DataPot.PrepaidDataSaldo }} />}
                                                </GridItem>}
                                                <GridItem>
                                                    <div style={{ textAlign: "center" }}>
                                                        <Button color="rose" style={{ borderRadius: "19px" }} onClick={() => navigateTo('/add-prepaid-quota')}>
                                                            Kjøp datapakke
                                                        </Button>
                                                    </div>
                                                </GridItem>
                                            </GridContainer>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            ) : ''}
                        {subscription && subscription.SaldoLoading ?
                            (
                                <GridContainer justify="center">
                                    <GridItem>
                                        <div style={{ paddingTop: '60px', paddingBottom: '20px', width: '280px', height: '317px', paddingRight: '5px' }}>
                                            <Loading message="" />
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            ) : ''}
                    </div>
                </GridItem>
                        <Hidden mdUp>
                            {subscription && subscription.IsPrepaid ?
                        (<GridContainer name="priceroot" justify="center" style={{ fontSize: '12px', paddingLeft: '5px', paddingRight: '5px' }}>
                                    <GridItem xs={12}>
                                        <table style={{ color: '#e91e63', width: '100%' }} cellPadding="0" cellSpacing="0">
                                            <tbody>
                                                <tr>
                                                    <td colSpan="4" style={{ textAlign: 'center' }}>
                                                        <Typography variant="subtitle1" color="inherit" className={classes.flex}>
                                                            <strong>Priser</strong>
                                                        </Typography>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center' }}><b>Tale</b></td>
                                                    <td style={{ textAlign: 'center', width: '25%' }}><b>SMS</b></td>
                                                    <td style={{ textAlign: 'center', width: '25%' }}><b>MMS</b></td>
                                                    <td style={{ textAlign: 'center' }}><b>Data</b></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center' }}><span style={{ fontSize: '10px' }}>Oppstart</span> 0,99</td>
                                                    <td style={{ textAlign: 'center' }}>0,69</td>
                                                    <td style={{ textAlign: 'center' }}>1,29</td>
                                                    <td style={{ textAlign: 'center' }}><span style={{ fontSize: '10px' }}> Per MB</span> 0,99</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center' }}><span style={{ fontSize: '10px' }}>Minuttpris</span> 0,69</td>
                                                    <td/>
                                                    <td/>
                                                    <td style={{ textAlign: 'center' }}><span style={{ fontSize: '10px' }}>Makspris per dag</span> 15,-</td>
                                                </tr>
                                            </tbody> 
                                        </table>
                                    </GridItem>
                                </GridContainer>) : ''}
                        </Hidden>
                {subscription && subscription.IsPrepaid ?
                    (<Hidden smDown>
                        <GridItem md={3}
                        >
                            <table style={{ marginLeft: '20px', color: '#e91e63', width: '100%', maxWidth: '300px' }} cellPadding="0" cellSpacing="0">
                                <tbody>
                                    <tr style={{ height: '36px' }}>
                                        <td colSpan="3" padding="none" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
                                            <Typography variant="subtitle1" color="inherit" className={classes.flex}>
                                                <strong>Priser</strong>
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr style={{ height: '36px' }}>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}><b>Tale</b></td>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>Oppstart<br/>Minuttpris</td>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>0,99<br/>0,69</td>
                                    </tr>
                                    <tr style={{ height: '36px' }}>
                                        <td colSpan="2" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}><b>SMS</b></td>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>0,59</td>
                                    </tr>
                                    <tr style={{ height: '36px' }}>
                                        <td colSpan="2" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}><b>MMS</b></td>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>1,29</td>
                                    </tr>
                                    <tr style={{ height: '36px' }}>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}><b>Data</b></td>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>Per MB<br />Makspris per dag</td>
                                        <td style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12' }}>0,99<br />15,-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </GridItem>
                    </Hidden>) : ''}
            </GridContainer>

        );
    }
}

Prepaid.propTypes = {
    subscription: PropTypes.object.isRequired,
};

export default Prepaid;
